<div class="flex flex-col w-full column-header">
  <div class="flex items-center gap-2">
    <span class="{{ headerStyleClass }}">{{ header }}</span>
    <span
      class="search-icon material-symbols-outlined cursor-pointer text-[20px]"
      (click)="op.toggle($event); toggleSearchBox()"
      [ngClass]="{
        visible: showSearchBox || (searchValue && searchValue.length),
        hidden: !showSearchBox && !searchValue,
      }"
      >search</span
    >
  </div>
  <div class="flex w-full items-center relative">
    <p-overlayPanel
      styleClass="saas-ui saas-ui-size-default column-header"
      #op
      (onHide)="toggleSearchBox()">
      <input
        id="search-input"
        pInputText
        placeholder="Search"
        [(ngModel)]="searchValue"
        pTooltip="Search is case-sensitive"
        tooltipPosition="top"
        tooltipStyleClass="saas-tooltip"
        [showDelay]="800"
        (keyup.enter)="publishSearchValue()" />
      <span
        *ngIf="searchValue && searchValue.length > 0"
        class="material-symbols-outlined clear-search-icon"
        (click)="clearSearchText()">
        close
      </span>
      <span
        *ngIf="searchValue && searchValue.length > 0"
        class="material-symbols-outlined submit-search-icon"
        (click)="publishSearchValue()">
        search
      </span>
    </p-overlayPanel>
  </div>
</div>
